module.exports = __webpack_public_path__ + "img/zhihuidangjian.b655a390.png";